import React, { Component } from "react";

import { connect } from "react-redux";

import { loginAdmin } from "../../../../actions/accountActions";

import { Translate } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";

import CheckCard from "../../../utils/components/CheckCard";

import { searchModule } from "../../../utils/Utils";
import { setAlert } from "../../../../actions/alertActions";
import "../../../../styles/components/account/login/modals/SelectUser.scss";

class SelectUser extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      search: "",
      users: [],
      userChecked: null,
    };

    this.handleCheck = this.handleCheck.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    if (this.props.listOfUsers) {
      this.safeSetState({
        users: this.props.listOfUsers,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.hasOwnProperty("listOfUsers") && this.props.listOfUsers) {
      if (prevProps.listOfUsers !== this.props.listOfUsers) {
        this.safeSetState({
          users: this.props.listOfUsers,
        });
      }
    }
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  handleCheck(e, user) {
    if (user !== this.state.userChecked) {
      this.safeSetState({
        userChecked: user,
      });
    }
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  handleLogin(e) {
    e.preventDefault();

    const userChecked = this.state.userChecked;

    this.props.loginAdmin(
      this.props.packet.username,
      this.props.packet.password,
      userChecked.email
    );
  }

  resetState() {
    this.safeSetState(() => ({
      search: "",
      userChecked: null,
    }));
  }

  render() {
    return (
      <Modal
        id="selectUser"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={() => this.resetState()}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <Translate value="user_select" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <div className="search-container">
              <input
                type="text"
                className="search"
                value={this.state.search}
                onChange={e => searchModule.setSearch(this, e.target.value)}
              />
            </div>
            <div className="users-list">
              {this.state.users
                .filter(i => searchModule.filter(this, i))
                .map(user => (
                  <CheckCard
                    key={user._id}
                    type="info"
                    avatar={user.imageContent}
                    name={user.name || ""}
                    info={`${user.email}`}
                    checked={user === this.state.userChecked}
                    onChange={e => this.handleCheck(e, user)}
                  />
                ))}
            </div>
          </>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" onClick={e => this.handleLogin(e)}>
            <Translate value="login_login" />
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  users: state.account.usersList,
});

export default connect(mapStateToProps, { setAlert, loginAdmin })(SelectUser);
